import { k as forceFocus } from './p-c44c2366.js';
import { t as transformTagName } from './p-c01ca34a.js';

const ACTIVATE_KEYS = ['Enter', ' '];
const isCosmosButton = (element) => element.tagName.toLowerCase() === transformTagName('cosmos-button');
const focusTrigger = async (trigger) => {
    if (isCosmosButton(trigger)) {
        await trigger.buttonFocus();
    }
    else {
        trigger.focus();
        await forceFocus(trigger);
    }
};
const useKeyboard = (refElements, actionItems) => {
    const { trigger, menu, tippyInstance } = refElements;
    let focusedIndex = -1;
    const handleTriggerKeyDown = async (event) => {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            focusedIndex = 0;
            tippyInstance.show();
            updateTabIndex();
            await forceFocus(actionItems[0].ref);
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            focusedIndex = actionItems.length - 1;
            tippyInstance.show();
            updateTabIndex();
            await forceFocus(actionItems[actionItems.length - 1].ref);
        }
    };
    const handleMenuKeyDown = async (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey) {
            return;
        }
        if (['ArrowDown', 'ArrowUp', 'Enter', ' ', 'Escape', 'Tab', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            switch (event.key) {
                case 'ArrowDown':
                    focusNextItem();
                    break;
                case 'ArrowUp':
                    focusPreviousItem();
                    break;
                case 'Enter':
                case ' ':
                    tippyInstance.hide();
                    await focusTrigger(trigger);
                    break;
                case 'Escape':
                case 'Tab':
                    tippyInstance.hide();
                    await focusTrigger(trigger);
                    break;
                case 'Home':
                    focusFirstItem();
                    break;
                case 'End':
                    focusLastItem();
                    break;
            }
        }
    };
    const focusNextItem = () => {
        const nextIndex = (focusedIndex + 1) % actionItems.length;
        focusedIndex = nextIndex;
        updateTabIndex();
        actionItems[nextIndex].ref.focus();
    };
    const focusPreviousItem = () => {
        const previousIndex = (focusedIndex - 1 + actionItems.length) % actionItems.length;
        focusedIndex = previousIndex;
        updateTabIndex();
        actionItems[previousIndex].ref.focus();
    };
    const focusFirstItem = () => {
        focusedIndex = 0;
        updateTabIndex();
        actionItems[0].ref.focus();
    };
    const focusLastItem = () => {
        const lastItem = actionItems.length - 1;
        focusedIndex = lastItem;
        updateTabIndex();
        actionItems[focusedIndex].ref.focus();
    };
    const handleTriggerClick = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const { isVisible } = tippyInstance.state;
        if (isVisible) {
            tippyInstance.hide();
        }
        else {
            tippyInstance.show();
            focusedIndex = 0;
            updateTabIndex();
        }
    };
    const updateTabIndex = () => {
        actionItems.forEach((item, index) => {
            item.ref.tabIndex = index === focusedIndex ? 0 : -1;
        });
    };
    const setup = () => {
        trigger.addEventListener('keydown', handleTriggerKeyDown);
        trigger.addEventListener('click', handleTriggerClick);
        menu.addEventListener('keydown', handleMenuKeyDown);
        updateTabIndex();
    };
    const cleanup = () => {
        trigger.removeEventListener('keydown', handleTriggerKeyDown);
        trigger.removeEventListener('click', handleTriggerClick);
        menu.removeEventListener('keydown', handleMenuKeyDown);
    };
    return {
        setup,
        cleanup,
    };
};

export { ACTIVATE_KEYS as A, useKeyboard as u };
